import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { SupportTicketForm } from '@/pages/support/form/support-ticket-form';
import { PROTECTED, SUPPORT } from '@/lib/constants/routes';

const RETURN_URL = `${PROTECTED}${SUPPORT}`;

export const Route = createFileRoute('/protected/_layout/support/_layout/new')({
  component: NewSupportTicketSheet,
});

/**
 * Apertura ticket in `SheetView` sopra la lista. Alla creazione si naviga al
 * dettaglio con `replace`, così il Back del browser torna alla lista e non
 * riapre il form appena inviato.
 */
function NewSupportTicketSheet() {
  const navigate = useNavigate();

  const close = () => navigate({ to: RETURN_URL, search: (old) => old });

  return (
    <SupportTicketForm
      onClose={close}
      onCreated={(ticketId) =>
        navigate({
          to: `${RETURN_URL}/${ticketId}`,
          search: (old) => old,
          replace: true,
        })
      }
    />
  );
}
